// extracted by mini-css-extract-plugin
export var avatarContainer = "_56-0";
export var avatarTypingWave = "_56-i";
export var gray = "_56-f";
export var green = "_56-c";
export var icon = "_56-9";
export var image = "_56-1";
export var lg = "_56-6";
export var md = "_56-5";
export var presenceDot = "_56-b";
export var red = "_56-d";
export var sm = "_56-4";
export var status = "_56-a";
export var typingDot = "_56-h";
export var typingPill = "_56-g";
export var xl = "_56-7";
export var xs = "_56-3";
export var xxl = "_56-8";
export var xxs = "_56-2";
export var yellow = "_56-e";